import {Patient} from "./patient.model";
import {LameSondeCalculator} from "./lame-sonde-calculator";

export class IsrResults {

  lame: string;
  sonde: string;
  atroIvd: number;
  atroX: number;
  atroY: number;
  ketaX: number;
  ketaY: number;
  etoY: number;
  suxaX: number;
  suxaY: number;
  suxaZ: string;
  suxaW: string;
  suxaV: string;

  lameSondeCalculator = new LameSondeCalculator();

  constructor(patient: Patient) {
    this.initResults(patient)
  }

  initResults(patient: Patient) {
    if (patient.totalMonths < 24) {
      let tmp1 = Math.trunc((20 * patient.weight) / 5);
      let rest = ((20 * patient.weight) % 5);
      this.atroIvd = (5 * tmp1 + (rest > 2.5 ? 5 : 0));
      this.atroX = Math.round((patient.weight * 2)) / 100;
      this.atroY = Math.round((patient.weight * 2)) / 10;
      this.ketaX = Math.round((patient.weight * 3));
      this.ketaY = Math.round((patient.weight * 3)) / 10;
    } else {
      this.etoY = Math.round((patient.weight * 0.3 * 0.5) * 10) / 10;
    }

    this.suxaZ = (patient.weight < 11 ? " 5ml " : " 10 ml");
    this.suxaW = (patient.weight < 11 ? " 1ml " : " la totalité ");
    this.suxaV = (patient.weight < 11 ? " 5ml " : " 10ml ");

    let K = (patient.weight < 10 ? 2 : 1);
    this.suxaY = Math.round(patient.weight * K);
    this.suxaX = Math.round(patient.weight * K) / 10;

    let lameSondeResult = this.lameSondeCalculator.getLameSonde(patient.weight);
    this.lame = lameSondeResult.lame;
    this.sonde = lameSondeResult.sonde;

  }
}



// WEBPACK FOOTER //
// ./src/models/isr-results.model.ts